import { render, staticRenderFns } from "./warnNotice.vue?vue&type=template&id=ca140a72&scoped=true&"
import script from "./warnNotice.vue?vue&type=script&lang=js&"
export * from "./warnNotice.vue?vue&type=script&lang=js&"
import style0 from "./warnNotice.vue?vue&type=style&index=0&id=ca140a72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca140a72",
  null
  
)

export default component.exports